<script>
import Countdown from "./Countdown";
import Description from "./Description";
import Confirmation from "./Confirmation";
import { mapState } from "vuex";

export default {
  data() {
    return {
      showConfirmation: false
    };
  },
  components: {
    Countdown,
    Description,
    Confirmation
  },

  computed: {
    ...mapState("newOrder", ["additional_informations"])
  },

  methods: {
    setOverflow(to) {
      document.querySelector("body").style.overflow = to;
    }
  },

  mounted() {
    this.setOverflow("hidden");
  },

  destroyed() {
    this.setOverflow("auto");
  }
};
</script>

<template>
  <section>
    <countdown @timeout="$emit('close')" :success="showConfirmation" />
    <confirmation v-if="showConfirmation" @comeback="showConfirmation = false" />
    <description v-else @saved="showConfirmation = true" />
    <div class="close" @click="$emit('close')">x</div>
  </section>
</template>

<style scoped>
section {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
  z-index: 999;
}

.close {
  color: var(--pink);
  font-size: 20px;
  font-weight: 300;
  position: fixed;
  top: 5px;
  right: 5px;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  text-align: center;
  border: 1px solid var(--pink);
  line-height: 38px;
  cursor: pointer;
  transition: all 0.24s ease;
}

.close:hover {
  background-color: var(--pink-off-white);
}

@media (min-width: 768px) {
  .close {
    font-size: 30px;
    width: 50px;
    height: 50px;
    top: 30px;
    right: 40px;
    font-weight: 100;
    line-height: 48px;
  }
}

@media (min-height: 600px) {
  section {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/CheckoutPopup/Index.vue